import PopupNg from '@/ui/PopupNg';
import { closeLuckyWheelNotification, setLuckyWheelAction } from 'nike-ui/src/components/lucky-wheel/h&s';
import { dispatch } from 're-framejs';
import { LuckyWheelActionType, LuckyWheelOfferType } from 'nike-ui/src/components/lucky-wheel/utils/enums';

export const handleClose = db => {
    PopupNg.dispatcher.close('luckyWheel/popup');
    return db.deleteIn(['bonus', 'luckyWheel']);
};

export const openLuckyWheelModal = db => {
    dispatch(closeLuckyWheelNotification);
    const { offer, offerType } = db.getIn(['bonus', 'luckyWheel'])?.toJS();
    if (offerType === LuckyWheelOfferType.OFFER) {
        PopupNg.dispatcher.open('luckyWheelConfirm/popup', {
            title: offer.lwName,
            subTitle: offer.lwDescription
        });
        return;
    }
    if (offerType === LuckyWheelOfferType.SPIN) {
        PopupNg.dispatcher.open('luckyWheel/popup');
    }
};

export const closeLuckyWheelConfirm = () => {
    PopupNg.dispatcher.close('luckyWheelConfirm/popup');
};

export const confirmBonus = () => {
    dispatch(
        setLuckyWheelAction(LuckyWheelActionType.ACCEPT, () => {
            PopupNg.dispatcher.close('luckyWheelConfirm/popup');
            PopupNg.dispatcher.open('luckyWheel/popup');
        })
    );
};
export const confirmRejectBonus = () => {
    PopupNg.dispatcher.close();
    PopupNg.dispatcher.open('luckyWheelConfirmReject/popup');
};

export const rejectBonus = () => {
    dispatch(
        setLuckyWheelAction(LuckyWheelActionType.DECLINE, () => {
            PopupNg.dispatcher.close('luckyWheelConfirmReject/popup');
        })
    );
};

export const closeRejectDialog = openLuckyWheel => {
    PopupNg.dispatcher.close();
    if (openLuckyWheel) dispatch(openLuckyWheelModal);
};
